import React from 'react';
import millify from 'millify';
import type { PLAYLIST_INFO_ACTIONS } from '@soundxyz/utils/constants/logging';
import { FEATURES } from '@soundxyz/utils/constants/logging';
import { MintsDrivenModal } from '@components/modals/MintsDrivenModal';
import { ModalType, useModal } from '@context/modal';
import { useLogInfo } from '@hooks/useLogInfo';
import { getSingularOrPlural } from '@utils/helpers';

export const MintsDrivenTrigger = ({
  className,
  playlistId,
  mintsDriven,
  infoAction,
}: {
  className?: string;
  playlistId: string;
  mintsDriven: number;
  infoAction?: keyof typeof PLAYLIST_INFO_ACTIONS;
}) => {
  const { openModal } = useModal();
  const logInfo = useLogInfo();

  const mintsDrivenLabel = getSingularOrPlural({ count: mintsDriven, word: 'mint' });

  const onClick = () => {
    if (infoAction) {
      logInfo({
        feature: FEATURES.PLAYLISTS,
        isArtistOnlyPage: false,
        action: infoAction,
        message: 'Mints driven count clicked',
        data: {
          playlistId,
        },
      });
    }
    openModal(ModalType.MINTS_DRIVEN, { body: <MintsDrivenModal playlistId={playlistId} /> });
  };

  return (
    <button className={className} onClick={onClick}>
      {millify(mintsDriven)} {mintsDrivenLabel} driven
    </button>
  );
};
